import { render, staticRenderFns } from "./CommPriceConf.vue?vue&type=template&id=827ce4a4&scoped=true"
import script from "./CommPriceConf.vue?vue&type=script&lang=js"
export * from "./CommPriceConf.vue?vue&type=script&lang=js"
import style0 from "./CommPriceConf.vue?vue&type=style&index=0&id=827ce4a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827ce4a4",
  null
  
)

export default component.exports